import { Provider } from '@angular/core';
import { CommentFactoryService } from './comment-factory/comment-factory.service';
import { CounterFactoryService } from './counter-factory/counter-factory.service';
import { CurrencyEntryFactoryService } from './currencies/currency-entry-factory.service';
import { DashboardFactoryService } from './dashboard-factory/dashboard-factory.service';
import { DataEntityActionFactoryService } from './data-entity-action-factory/data-entity-action-factory.service';
import { DataEntityTemplateFactoryService } from './data-entity-template-factory/data-entity-template-factory.service';
import { DataReactionWithRelationsFactoryService } from './data-entity-trigger-factory/data-entity-trigger-factory.service';
import { DataEntityWorkflowFactoryService } from './data-entity-workflow-factory/data-entity-workflow-factory.service';
import { DataEntryFactoryService } from './data-entry-factory/data-entry-factory.service';
import { DataEntryHistoryFactoryService } from './data-entry-history-factory/data-entry-history-factory.service';
import { DataModuleFactoryService } from './data-module-factory/data-module-factory.service';
import { QueryFactoryService } from './data-query-factory/query-factory.service';
import { DataRelationsFactoryService } from './data-relations-factory/data-relations-factory.service';
import { StatisticQueryFactoryService } from './data-statistic-query-factory/statistic-query-factory.service';
import { DataViewsFactoryService } from './data-views-factory/data-views-factory.service';
import { DataViewsPermissionsForEndUserFactoryService } from './data-views-factory/data-views-permissions-for-end-user-factory.service';
import { DelegationFactoryService } from './delegation-factory/delegation-factory.service';
import { EndUserDataViewsFactoryService } from './end-user-data-views-factory/end-user-data-views-factory.service';
import { EntityFactoryService } from './entity-factory/entity-factory.service';
import { EntityVersionChangesFactoryService } from './entity-version-changes-factory/entity-version-changes-factory.service';
import { EntryEmailsFactoryService } from './entry-emails-factory/entry-emails-factory.service';
import { EntryWorkFlowStatusFactoryService } from './entry-workflow-status-factory/entry-workflow-status-factory.service';
import { FieldFactoryService } from './field-factory/field-factory.service';
import { FunctionsFactoryService } from './functions-factory/functions-factory.service';
import { GenericViewsFactoryService } from './generic-views-factory/generic-views-factory.service';
import { InternalEntityFactoryService } from './internal-entity-factory/internal-entity-factory.service';
import { LockHistoryService } from './lock-history-factory/lock-history-factory.service';
import {
  EmailEntryFactoryService,
  SmsEntryFactoryService,
  SystemLogsFactoryService,
} from './logs-factory';
import { DuplicatedCollectionFactoryService } from './lov-factory/duplicated-collection-factory.service';
import { LovFactoryService } from './lov-factory/lov-factory.service';
import { SharedCollectionFactoryService } from './lov-factory/shared-collection-factory.service';
import { NavigationFactoryV2Service } from './navigation-factory/navigation-factory-v2.service';
import { NotificationFactoryService } from './notification-factory/notification-factory.service';
import { PermissionsFactoryService } from './permissions-factory/permissions-factory.service';
import { PublicGenericViewsFactoryService } from './public-generic-view-factory/public-generic-view-factory.service';
import { ReportsFactoryService } from './reports-factory/reports-factory.service';
import { SpaceEntryFactoryService } from './space-entry-factory/space-entry-factory.service';
import { SystemButtonDataFactoryService } from './system-button-data-factory/system-button-data-factory.service';
import { TimelinePostFactoryService } from './timeline-post-factory/timeline-post-factory.service';
import { TransformationFactoryService } from './transformation-factory/transformation-factory.service';
import { UserFactoryService } from './user-factory/user-factory.service';
import { WorkflowActionFactoryService } from './workflow-action-factory/workflow-action-factory.service';
import { WorkflowStepFactoryService } from './workflow-step-factory/workflow-step-factory.service';

export const CORE_FACTORIES: Provider[] = [
  UserFactoryService,
  PermissionsFactoryService,
  DataEntityWorkflowFactoryService,
  WorkflowStepFactoryService,
  WorkflowActionFactoryService,
  DataEntityActionFactoryService,
  DataReactionWithRelationsFactoryService,
  FieldFactoryService,
  InternalEntityFactoryService,
  EntityFactoryService,
  DataEntryFactoryService,
  DataViewsFactoryService,
  DataViewsPermissionsForEndUserFactoryService,
  DataRelationsFactoryService,
  DataModuleFactoryService,
  GenericViewsFactoryService,
  DashboardFactoryService,
  StatisticQueryFactoryService,
  ReportsFactoryService,
  LovFactoryService,
  DuplicatedCollectionFactoryService,
  SharedCollectionFactoryService,
  QueryFactoryService,
  NotificationFactoryService,
  TimelinePostFactoryService,
  CommentFactoryService,
  NavigationFactoryV2Service,
  EntryWorkFlowStatusFactoryService,
  CounterFactoryService,
  SystemButtonDataFactoryService,
  DataEntryHistoryFactoryService,
  DataEntityTemplateFactoryService,
  SpaceEntryFactoryService,
  PublicGenericViewsFactoryService,
  EmailEntryFactoryService,
  SystemLogsFactoryService,
  LockHistoryService,
  SmsEntryFactoryService,
  CurrencyEntryFactoryService,
  DelegationFactoryService,
  EntryEmailsFactoryService,
  FunctionsFactoryService,
  EndUserDataViewsFactoryService,
  EntityVersionChangesFactoryService,
  TransformationFactoryService,
];

export {
  CommentFactoryService,
  CounterFactoryService,
  CurrencyEntryFactoryService,
  DashboardFactoryService,
  DataEntityActionFactoryService,
  DataEntityTemplateFactoryService,
  DataEntityWorkflowFactoryService,
  DataEntryFactoryService,
  DataEntryHistoryFactoryService,
  DataModuleFactoryService,
  DataReactionWithRelationsFactoryService,
  DataRelationsFactoryService,
  DataViewsFactoryService,
  DataViewsPermissionsForEndUserFactoryService,
  DelegationFactoryService,
  DuplicatedCollectionFactoryService,
  EmailEntryFactoryService,
  EndUserDataViewsFactoryService,
  EntityFactoryService,
  EntityVersionChangesFactoryService,
  EntryEmailsFactoryService,
  EntryWorkFlowStatusFactoryService,
  FieldFactoryService,
  FunctionsFactoryService,
  GenericViewsFactoryService,
  InternalEntityFactoryService,
  LockHistoryService,
  LovFactoryService,
  NavigationFactoryV2Service,
  NotificationFactoryService,
  PermissionsFactoryService,
  PublicGenericViewsFactoryService,
  QueryFactoryService,
  ReportsFactoryService,
  SharedCollectionFactoryService,
  SmsEntryFactoryService,
  SpaceEntryFactoryService,
  StatisticQueryFactoryService,
  SystemButtonDataFactoryService,
  SystemLogsFactoryService,
  TimelinePostFactoryService,
  TransformationFactoryService,
  UserFactoryService,
  WorkflowActionFactoryService,
  WorkflowStepFactoryService,
};
